import React from "react";
import ChangePasswordPage from "../components/ChangePassword";

const ChangePassword = () => {
  return (
    <div className="container mx-auto">
      <ChangePasswordPage />
    </div>
  );
};

export default ChangePassword;
